/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { Title } from 'web-ui-components/lib/atoms/text';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import PickerLayout from '../../../pickerLayout/components/LayoutContainer/LayoutContainer';

import pageContent, { contentPropTypes } from '../../components/managePayeeList/managePayeeList.content';
import { withScrollTop } from '../../../containers/withScrollTop';
import withContent from '../../../containers/withContent';
import DeleteConfirmationModal from '../../../sharedComponents/DeleteConfirmationModal';
import { setSelectedPayee, submitDeletePayee, resetManagePayee } from '../../states/action';
import { getSourceAccountId, getPayeeType } from '../../states/selectors';
import Notifications from '../../../sharedComponents/Notifications';
import { clearNotification } from '../../../states/notifications/actions';
import { getAllNotifications } from '../../../states/notifications/selectors';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import { isIFTEnabled } from '../../../states/capabilities/selectors';
import { getAccountsForAddPayee } from '../../../states/accounts/selectors';
import { accountsForAddPayeePropTypes } from '../../../payees/states/addPayee/propTypes';
import { goToViewPayeePage, goToEditPayeePage, goToEditChapsPage } from '../../../states/api/fasterPaymentActions';
import { getPage } from '../../../states/page/selectors';
import { setBackPage } from '../../../states/page/actions';
import { TYPE_DOMESTIC_PAYEE } from '../../../config';
import { getManagePayeeList } from '../../../states/payees/selectors';
import { setPagingLayoutType } from '../../../states/accountPaging/actions';
import { PAYEE_PICKER_LAYOUT } from '../../../pickerLayout/constants';
import { PageHeading } from 'web-ui-components/lib/typography/headings';

const mapState = (state) => ({
	sourceAccountId: getSourceAccountId(state),
	notification: getAllNotifications(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
	payeeType: getPayeeType(state),
	isIFTEnabled: isIFTEnabled(state),
	accountsForAddPayee: getAccountsForAddPayee(state),
	currentPage: getPage(state),
	payees: getManagePayeeList(state),
});

const mapDispatch = (dispatch) => ({
	setSelectedPayee: (selectedPayee) => dispatch(setSelectedPayee(selectedPayee)),
	submitDeletePayee: (details) => dispatch(submitDeletePayee(details)),
	clearNotification: (id) => dispatch(clearNotification(id)),
	goToViewPayeePage: () => dispatch(goToViewPayeePage()),
	goToEditPayeePage: () => dispatch(goToEditPayeePage()),
	goToEditChapsPage: () => dispatch(goToEditChapsPage()),
	setBackPage: (currentPage) => dispatch(setBackPage(currentPage)),
	resetManagePayee: () => dispatch(resetManagePayee()),
	setPagingLayoutType: (layoutType) => dispatch(setPagingLayoutType(layoutType)),
});

export class ManagePayeeList extends Component {
	constructor(props) {
		super(props);

		this.handleTransferPayee = this.handleTransferPayee.bind(this);
		this.handleDeletePayee = this.handleDeletePayee.bind(this);
		this.confirmDeletePayee = this.confirmDeletePayee.bind(this);
		this.handleViewPayee = this.handleViewPayee.bind(this);
		this.handleEditPayee = this.handleEditPayee.bind(this);
		this.handleEditChaps = this.handleEditChaps.bind(this);
		this.state = {
			isModalOpen: false,
		};
	}

	componentDidMount() {
		const { setPagingLayoutType } = this.props;
		setPagingLayoutType(PAYEE_PICKER_LAYOUT);
	}

	componentWillReceiveProps(newProps) {
		const { notification = [], clearNotification, payeeType } = this.props;
		const notificationId = notification[0] && notification[0].id;

		if (newProps.payeeType !== payeeType && notificationId) {
			clearNotification(notificationId);
		}
	}

	componentWillUnmount() {
		const { notification = [], clearNotification } = this.props;
		const notificationId = notification[0] && notification[0].id;

		clearNotification(notificationId);
	}

	handleTransferPayee() {
		const { handleRoute } = this.props;
		handleRoute('WEB-BENEFICIARY-SYNC');
	}

	handleDeletePayee(event, selectedPayee) {
		event.stopPropagation();
		const { setSelectedPayee, notification = [], clearNotification } = this.props;
		const notificationId = notification[0] && notification[0].id;
		clearNotification(notificationId);
		this.setState({ isModalOpen: true });
		setSelectedPayee(selectedPayee);
	}

	confirmDeletePayee() {
		const {
			sourceAccountId,
			submitDeletePayee,
			content: { deletePayeeSuccessMessage },
		} = this.props;
		const closeDeleteConfirmationModal = () => this.setState({ isModalOpen: false });

		submitDeletePayee({
			sourceAccountId,
			deletePayeeSuccessMessage,
			closeDeleteConfirmationModal,
		});
	}

	handleViewPayee(selectedPayee) {
		const { setSelectedPayee, goToViewPayeePage, currentPage, setBackPage } = this.props;
		setSelectedPayee(selectedPayee);
		setBackPage(currentPage);
		goToViewPayeePage();
	}

	handleEditPayee(event, selectedPayee) {
		event.stopPropagation();
		const { setSelectedPayee, goToEditPayeePage, currentPage, setBackPage } = this.props;
		setSelectedPayee(selectedPayee);
		setBackPage(currentPage);
		goToEditPayeePage();
	}

	handleEditChaps(event, selectedPayee) {
		event.stopPropagation();
		const { setSelectedPayee, goToEditChapsPage, currentPage, setBackPage } = this.props;
		setSelectedPayee(selectedPayee);
		setBackPage(currentPage);
		goToEditChapsPage();
	}

	render() {
		const {
			content,
			handleImportPayees,
			hasApiCallInProgress,
			payeeType,
			accountsForAddPayee,
			handleRoute,
			handleBack,
			isBootStrapInProgress,
		} = this.props;

		const { header } = content;
		const { isModalOpen } = this.state;

		const isFileImportAllowed = accountsForAddPayee.length > 0 && payeeType === TYPE_DOMESTIC_PAYEE;

		return (
			<ServicingSection>
				<BackButton data-cy="back-button" onClick={handleBack} disabled={hasApiCallInProgress} />

				<PageHeading>{header}</PageHeading>
				<div className="u-margin-bottom-2">
					<Notifications />
				</div>
				<PickerLayout
					handlePayeeSelect={(account) => this.handlePayeeSelect(account)}
					getIsPayeeSelected={this.getIsPayeeSelected}
					isManageYourPayee
					handleViewPayee={this.handleViewPayee}
					handleDeletePayee={this.handleDeletePayee}
					handleEditPayee={this.handleEditPayee}
					handleEditChaps={this.handleEditChaps}
					handleImportPayees={handleImportPayees}
					isFileImportAllowed={isFileImportAllowed}
					handleTransferPayee={this.handleTransferPayee}
					isBootStrapInProgress={isBootStrapInProgress}
				/>
				<DeleteConfirmationModal
					confirmDeletePayee={this.confirmDeletePayee}
					handleClose={() => this.setState({ isModalOpen: false })}
					isModalOpen={isModalOpen}
					hasApiCallInProgress={hasApiCallInProgress}
					handleRoute={handleRoute}
				/>
			</ServicingSection>
		);
	}
}

ManagePayeeList.propTypes = {
	content: PropTypes.shape(contentPropTypes).isRequired,
	handleImportPayees: PropTypes.func.isRequired,
	submitDeletePayee: PropTypes.func.isRequired,
	setSelectedPayee: PropTypes.func.isRequired,
	sourceAccountId: PropTypes.string.isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	clearNotification: PropTypes.func.isRequired,
	notification: PropTypes.arrayOf(PropTypes.string.isRequired),
	handleRoute: PropTypes.func.isRequired,
	payeeType: PropTypes.bool.isRequired,
	accountsForAddPayee: PropTypes.arrayOf(PropTypes.shape(accountsForAddPayeePropTypes)).isRequired,
	goToViewPayeePage: PropTypes.func.isRequired,
	goToEditPayeePage: PropTypes.func.isRequired,
	currentPage: PropTypes.string.isRequired,
	setBackPage: PropTypes.func.isRequired,
	handleBack: PropTypes.func.isRequired,
	setPagingLayoutType: PropTypes.func.isRequired,
	isBootStrapInProgress: PropTypes.bool,
};

export const connectWrapper = connect(mapState, mapDispatch)(ManagePayeeList);
export default withScrollTop(withContent({ content: pageContent })(connectWrapper));
